import React, { useEffect } from 'react';
import { connect } from "react-redux";
import { setBadge, loadAllNotifications } from "../../../state/actionsCreators";
import { NotificationCard } from 'Components/Molecules/M_Reusable/NotificationCard';
import { NotificationCardVolcano } from 'Components/Molecules/M_Reusable/NotificationCardVolcano';
import { getLocalTime } from 'Components/Atoms/A_Reusable/ActualDate';

let notification_number = 0;

const validateNotification = type => {
	switch ( type ) {
		case 'Semanales':
			return 'Boletín semanal';
		case 'Mensuales':
			return 'Boletín mensual';
		default:
			return 'Boletín extraordinario'
	}
}

const Notifications = ({ notifications, setBadge }) => {
	
	let allNotifications = [];
	useEffect(() => {
		setBadge( notification_number );
	});

	const buildNotifications = () => {
		notifications.forEach(( notification, index ) => {
			if ( notification.type === 'earthquake' ) {
				allNotifications.push(
					<NotificationCard
						key = { notification.id } 
						notification = { notification } 
						date = { notification.properties.localTime }
					/>
				)
			}
			else if ( notification.type === 'volcano' ) {
				notification.properties.bulletins.forEach(( bulletin, bulletin_key ) => {
					allNotifications.push(
						<NotificationCardVolcano
							key = { `bulletin${ index }_${ bulletin_key }` }
							mensuales 
							type = { validateNotification( bulletin.type ) } 
							notification={ notification } 
							bulletin = { bulletin }
							link = {`/detallevolcan/${ notification.id }/`}
							date = { getLocalTime( bulletin.update ) }
							actual = { bulletin.update }
							ex
						/>
					)
				});
				if ( notification.properties.news !== null ) {
					notification.properties.news.forEach(( news, news_key ) => {
						allNotifications.push(
							<NotificationCardVolcano
								key = { `news${index}_${news_key}` }
								img = { notification.properties.image }
								type = "Noticia" 
								notification = { notification }
								noti = { news }
								link = {`/detallevolcan/${ notification.id }/`} 
								date = { getLocalTime( news.date ) }
								actual = { news.date }
							/>
						)
					});
				}
			}
		});
		return allNotifications.sort(( element1, element2 ) => {
			if( element1.props.date < element2.props.date ){
				return 1
			}
			if ( element1.props.date > element2.props.date ){
				return -1
			}
			return 0
		});
	}
	

    return(
		<div className="notifications-container" >
			{ buildNotifications() }
		</div>
    )
}

const mapStateToProps = ({ notifications, badge, allNotifications }) => ({
	notifications, badge, allNotifications
});
  
const mapDispatchToProps = { setBadge, loadAllNotifications };

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);